import {initCardSearch} from './Filter';

const initializedContainers = new WeakSet();

export const initializeCardFilters = root => {
    root.querySelectorAll('[data-controller="card-filter"]').forEach(container => {
        if (initializedContainers.has(container)) {
            return;
        }

        initializedContainers.add(container);

        initCardSearch(container);
    });
};
